import { HttpClient } from "@/app/api/HttpClient"
import { API_PREFIX_STORES_PATH } from "@/constants/prefix-path-api"
import { StoreListResponse, StoreResponse } from "@/types/codegen/data-contracts"
import { RequestParams } from "@/types/codegen/http-client"

export const getStores = async (params?: RequestParams) => {
  return await HttpClient.get<StoreListResponse>(`${API_PREFIX_STORES_PATH}`, { params: params })
}

export const getStoreById = async (id: number, params?: RequestParams) => {
  const queryParams = {
    populate: "*",
    sort: "createdAt:desc",
    ...params,
  }

  return await HttpClient.get<StoreResponse>(`${API_PREFIX_STORES_PATH}/${id}`, { params: queryParams })
}
